/* ==========================================================================

 PointyModal

 Description: Creates a modal which points to an element like a tooltip but
              should be activated by click

 ========================================================================== */
'use strict';

var _ = require('underscore'),
  Tooltip = require('./Tooltip'),

  PointyModalView = Tooltip.extend({

    /**
     * options.el - the element to trigger the tooltip
     */
    initialize: function(options) {
      var self = this;
      Tooltip.prototype.initialize.call(this, _.defaults(options, {
        theme: 'Modal--pointy',
        side: ['bottom', 'left'],
        positionTracker: true,
        interactive: true,
        trigger: 'click',
        functionAfter: function() {
          // Event raised after the tooltip has closed
          self.trigger('tooltip:close');
        }
      }));
    }

  });

module.exports = PointyModalView;



// WEBPACK FOOTER //
// ./assets/js/components/PointyModalView.js